/* eslint-disable no-nested-ternary */
import React, { useMemo } from 'react'
import { currencyMapping, FetchQRStatus } from '@entities/payment'
import { parseAmount } from '@shared/lib'
import { pennyToRubles } from '@shared/lib/money'
import { OperationDetailsRs } from '@root/api/ump-ewallet'

export interface InfoRowProps {
  label: string
  value: string | React.ReactNode
}

interface UseInfoRowsProps {
  data: FetchQRStatus | OperationDetailsRs
  formattedDate: string
  loadingComponent: React.ReactNode
  isSBP: boolean
}

const getPaymentMethodLabel = (isSBP: boolean, data?: OperationDetailsRs) => {
  if (isSBP) return 'СБП'
  if (data?.isCvcProvided || data?.is3dsPerformed) return 'Банковская карта'

  return 'счёт МТС'
}

export const useInfoRowsResult = ({ data, formattedDate, loadingComponent, isSBP }: UseInfoRowsProps): InfoRowProps[] =>
  useMemo(() => {
    const paymentMethodLabel = getPaymentMethodLabel(isSBP, data as OperationDetailsRs)

    const baseRows = [
      {
        label: 'Способ оплаты',
        value: !data ? loadingComponent : paymentMethodLabel,
      },
      {
        label: 'Время',
        value: !data ? loadingComponent : formattedDate,
      },
    ]

    if (isSBP) {
      return [
        {
          label: 'Сумма',
          value: !data
            ? loadingComponent
            : `${pennyToRubles(data?.amount?.total as string)} ${currencyMapping[data?.amount?.currency as string]}`,
        },
        ...baseRows,
      ]
    }

    const operationData = data as OperationDetailsRs

    return [
      {
        label: 'Сумма',
        value: !data
          ? loadingComponent
          : `${parseAmount(operationData?.amount?.total as string)} ${
              currencyMapping[operationData?.amount?.currency as number]
            }`,
      },
      ...baseRows,
    ]
  }, [data, formattedDate, isSBP, loadingComponent])
